<div class="upsell-sticky-bar sticky w-full z-50 left-0 bottom-0 bg-dmp-lightgray">
  <div class="upsell-sticky-bar__container mx-auto flex flex-col desktop:flex-row items-center py-6 gap-1">
    <button 
      data-qa="cta-yes" 
      class="upsell-product-box__button-yes mx-auto max-w-[300px] desktop:max-w-[370px] w-full bg-dmp-gold hover:bg-dmp-gold-dark text-sm uppercase p-4 text-white font-extrabold leading-tight"
      (click)="nextPage(true)" 
      data-te="cta-yes" 
      [innerHTML]="buttonYesText">
    </button>

    <button 
      data-qa="cta-no" 
      class="upsell-product-box__button-no mx-auto max-w-[300px] desktop:max-w-[370px] w-full bg-dmp-gray text-sm uppercase p-4 text-white font-extrabold leading-tight"
      (click)="nextPage(false)" 
      [innerHTML]="buttonNoText" 
      data-te="cta-no">
    </button>
  </div>
</div>